/**
 * Logikk for Department Action Plan
 * Definerer strukturen for tiltaksplaner og styringsinformasjon.
 */

export const ACTION_STATUS = {
  NOT_STARTED: { label: 'Ikke startet', color: 'slate' },
  IN_PROGRESS: { label: 'Pågår', color: 'indigo' },
  COMPLETED: { label: 'Fullført', color: 'emerald' },
  DELAYED: { label: 'Forsinket', color: 'rose' }
};

export const departmentActionPlans = [
  {
    deptId: 'd1',
    name: 'Utvikling',
    manager: 'Sarah Chen',
    summary: 'Avdelingen preges av høyt teknisk trykk og fallende psykologisk trygghet. Fokus for planen er skjerming og kulturbygging.',
    managementRecs: [
      'Gjennomfør ukentlig "prioriterings-vask" for å fjerne lavverdi-oppgaver.',
      'Etabler faste de-briefing sesjoner etter kritiske leveranser.'
    ],
    actions: [
      {
        id: 'a101',
        problem: 'Systemisk stress og høyt arbeidspress',
        intervention: 'Ressursgjennomgang og kapasitetsanalyse',
        responsible: 'Sarah Chen',
        timeline: 'Uke 1-4',
        followUp: 'August 2024',
        status: 'IN_PROGRESS'
      },
      {
        id: 'a102',
        problem: 'Taushetskultur ved feil',
        intervention: 'Workshop: Psykologisk Trygghet',
        responsible: 'HR v/ Jonas',
        timeline: 'Uke 6',
        followUp: 'September 2024',
        status: 'NOT_STARTED'
      }
    ]
  },
  {
    deptId: 'd2',
    name: 'Salg',
    manager: 'Morten Kraft',
    summary: 'Konfliktnivået i teamet påvirker prestasjonene. Planen fokuserer på relasjonell avklaring og kommunikasjon.',
    managementRecs: [
      'Individuelle samtaler med nøkkelpersoner for å kartlegge uformelle allianser.',
      'Revisjon av provisjonsmodell for å fremme samarbeid fremfor intern konkurranse.'
    ],
    actions: [
      {
        id: 'a201',
        problem: 'Relasjonelle gnisninger i lead-generering',
        intervention: 'Fasilitert dialogmøte (Mekling)',
        responsible: 'Ekstern konsulent',
        timeline: 'Uke 2-3',
        followUp: 'Juni 2024',
        status: 'COMPLETED'
      },
      {
        id: 'a202',
        problem: 'Uklare forventninger til samarbeid',
        intervention: 'Etablering av felles kjøreregler',
        responsible: 'Morten Kraft',
        timeline: 'Uke 4-5',
        followUp: 'August 2024',
        status: 'IN_PROGRESS'
      }
    ]
  },
  {
    deptId: 'd3',
    name: 'Kundesupport',
    manager: 'Linda Vang',
    summary: 'Stabil drift, men tegn til emosjonell utmatting. Forebyggende tiltak er i fokus.',
    managementRecs: [
      'Innføre rotasjonsordning for krevende saker.',
      'Sikre 100% dekning på 1-til-1 samtaler med fokus på mestring.'
    ],
    actions: [
      {
        id: 'a301',
        problem: 'Økende emosjonell belastning',
        intervention: 'Kurs i grensesetting og selvledelse',
        responsible: 'Bedriftshelsetjenesten',
        timeline: 'Uke 8-10',
        followUp: 'Oktober 2024',
        status: 'NOT_STARTED'
      }
    ]
  }
];

export const getActionStatusDetails = (statusKey) => ACTION_STATUS[statusKey] || ACTION_STATUS.NOT_STARTED;